const normalizeFullWidthChars = (value) => {
  if (!value || typeof value !== 'string') {
    return value;
  }

  return value
    .replace(/[\uFF01-\uFF5E]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0))
    .replace(/\u3000/g, ' ');
};

export default normalizeFullWidthChars;
